import { Link } from '@mui/material';
import { useAtom } from 'jotai';

import LargeCard from '@/components/LargeCard';
import selectedVulnerabilityAtom from '@/pages/VulnerabilityManagement/VMPVulnerabilities/VMPVulnerabilities.store';

import useStyles from './VulnerabilityDetailsMainInformation.styles';

const VulnerabilityDetailsMainInformation = () => {
  const [{ description, solution, references }] = useAtom(
    selectedVulnerabilityAtom
  );
  const { classes } = useStyles();
  const normalizedReferences: unknown = references;

  let allReferences: string[] = [];

  if (typeof normalizedReferences === 'string') {
    allReferences = normalizedReferences.split(' ').filter(Boolean);
  } else if (Array.isArray(normalizedReferences)) {
    allReferences = normalizedReferences
      .map((reference: unknown) => {
        if (typeof reference === 'string') {
          return reference;
        }

        if (
          reference &&
          typeof reference === 'object' &&
          'url' in reference &&
          typeof reference.url === 'string'
        ) {
          return reference.url;
        }

        return '';
      })
      .filter(Boolean);
  }

  return (
    <>
      <LargeCard title="Details">{description}</LargeCard>
      {solution && <LargeCard title="Solutions">{solution}</LargeCard>}
      <LargeCard title="References">
        {allReferences?.map((reference) => (
          <div key={reference} className={classes.references}>
            <Link
              underline="none"
              rel="noopener"
              target="_blank"
              href={reference}
              key={reference}
            >
              {reference.length > 300
                ? `${reference.slice(0, 300)}...`
                : reference}
            </Link>
          </div>
        ))}
      </LargeCard>
    </>
  );
};

export default VulnerabilityDetailsMainInformation;
